var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMailbox = function SvgMailbox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2725 86.8393V62.9602H102.579C112.852 62.9602 121.2 71.0988 121.2 81.1155V110.987C121.2 114.206 118.54 116.8 115.237 116.8H58.2725",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9211 116.711H43.5039C40.4767 116.711 38 114.296 38 111.344V83.083C38 71.8143 47.3566 62.6919 58.9147 62.6919C70.4728 62.6919 79.8293 71.8143 79.8293 83.083V116.711H79.9211Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4053 90.1484V46.3253",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.036 44H93.4053V55.4477H113.036V44Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3497 93.9047C99.5282 93.9047 101.294 92.1829 101.294 90.059C101.294 87.935 99.5282 86.2133 97.3497 86.2133C95.1713 86.2133 93.4053 87.935 93.4053 90.059C93.4053 92.1829 95.1713 93.9047 97.3497 93.9047Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6461 86.8393H50.5674V116.174H79.6461V86.8393Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export { SvgMailbox as ReactComponent };
export default __webpack_public_path__ + "static/media/mailbox.1a4d59a9.svg";